<div class="container-fluid">
    <div class="page-header-banner">
        <h1 *ngIf="isNew">Create new gallery</h1>
        <h1 *ngIf="!isNew">Edit gallery</h1>
    </div>


    <div class="row mb-4">
        <div class="col-xl-10 offset-xl-1">
            <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="onSubmit()">

                <div *ngIf="item">

                    <div class="data-container m-0 mt-3 mb-3">
                        <h1 class="mt-0">Gallery overview</h1>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="mb-3">
                                    <label>Give this gallery a name</label>
                                    <input
                                        type="text"
                                        class="form-control bordered"
                                        [ngClass]="{'is-invalid' : form.controls.name.invalid && form.controls.name.dirty}"
                                        formControlName="name" />
                                    <div class="invalid-feedback">Enter a valid name</div>
                                </div>
                                <div class="mb-3">
                                    <label>Gallery height (pixels)</label>
                                    <input
                                        type="number"
                                        class="form-control bordered"
                                        [ngClass]="{'is-invalid' : form.controls.maxHeight.invalid && form.controls.maxHeight.dirty}"
                                        placeholder="example 500"
                                        formControlName="maxHeight" />
                                </div>

                                <div class="mb-3">
                                    <label>Maximum image width (pixels)</label>
                                    <input
                                        type="number"
                                        class="form-control bordered"
                                        [ngClass]="{'is-invalid' : form.controls.maxWidth.invalid && form.controls.maxWidth.dirty}"
                                        placeholder="example 1440"
                                        formControlName="maxWidth" />
                                </div>
                                <!-- <div class="mb-3">
                                    <label>Image border (pixels)</label>
                                    <input
                                        type="number"
                                        class="form-control bordered"
                                        [ngClass]="{'is-invalid' : form.controls.border.invalid && form.controls.border.dirty}"
                                        formControlName="border" />
                                </div> -->

                            </div>

                            <div class="col-lg-6">
                                <div class="mb-3">
                                    <label>How much space should the images have between them? (pixels)</label>
                                    <input
                                        type="number"
                                        class="form-control bordered"
                                        [ngClass]="{'is-invalid' : form.controls.spacing.invalid && form.controls.spacing.dirty}"
                                        placeholder="example 15"
                                        formControlName="spacing" />
                                </div>
                                <div class="mb-3">
                                    <label>How many images should show in the slider at once?</label>
                                    <input
                                        type="number"
                                        class="form-control bordered"
                                        [ngClass]="{'is-invalid' : form.controls.slidesPerView.invalid && form.controls.slidesPerView.dirty}"
                                        placeholder="example 4"
                                        formControlName="slidesPerView" />
                                </div>
                                <div class="mb-2">
                                    <a (click)="toggleValue('loopImages')">
                                        <i
                                            class="toggle fa"
                                            [ngClass]="{
                                            'fa-toggle-on text-success': form.value.loopImages,
                                            'fa-toggle-off' : !form.value.loopImages}"></i>
                                            Loop gallery images?
                                    </a>
                                </div>
                                <div class="mb-2">
                                    <a (click)="toggleValue('showNav')">
                                        <i
                                            class="toggle fa"
                                            [ngClass]="{
                                            'fa-toggle-on text-success': form.value.showNav,
                                            'fa-toggle-off' : !form.value.showNav}"></i>
                                            Show naviation arrows?
                                    </a>
                                </div>
                                <div class="mb-2">
                                    <a (click)="toggleValue('showDots')">
                                        <i
                                            class="toggle fa"
                                            [ngClass]="{
                                            'fa-toggle-on text-success': form.value.showDots,
                                            'fa-toggle-off' : !form.value.showDots}"></i>
                                            Show naviation dots?
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="text-end mt-4">
                            <button type="submit" class="btn btn-primary btn-round">Save</button>
                        </div>

                    </div>

                    <div class="data-container m-0 mb-3">
                        <div class="dropzone dropzone-container"
                            [dropzone]="uploadConfig"
                            (error)="onUploadError($event)"
                            (uploadprogress)="uploadprogress($event)"
                            (queueComplete)="queueComplete($event)"
                            (success)="onUploadSuccess($event)">

                            <div class="dz-details">
                                <div class="dz-filename"><span data-dz-name></span></div>
                                <div class="dz-size" data-dz-size></div>
                                <img data-dz-thumbnail />
                            </div>
                            <!--<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>-->
                            <!--<div class="dz-success-mark"><span>✔</span></div>-->
                            <!--<div class="dz-error-mark"><span>✘</span></div>-->
                            <!--<div class="dz-error-message"><span data-dz-errormessage></span></div>-->
                        </div>
                    </div>
                    <div class="data-container m-0 mb-3">
                        <h1 class="mt-0">Gallery images</h1>
                        <p>Images are preview only and may not appear at the same aspect ratio as the live site</p>
                        <p>Click edit to add floating text and button links</p>
                        <div
                            dragula="roomImages"
                            [(dragulaModel)]="item.images"
                            (dragulaModelChange)="drop($event)">

                            <div style="display: inline-block;"
                                class="gallery-image-tile-holder"
                                *ngFor="let image of item.images; let i = index">
                                <div class="gallery-image-tile" [ngStyle]="{'background-image': 'url(' + image.imageUrl + ')'}">

                                </div>
                                <div
                                    class="gallery-image-toolbar">
                                    <div class="row">
                                        <div class="col-6">
                                            <button type="button" class="btn btn-danger btn-sm"
                                                (click)="deleteConfirm(image)">
                                                <img src="assets/images/icon-trash.svg" class="gallery-manage-trash">
                                            </button>
                                        </div>
                                        <div class="col-6 text-end">
                                            <button type="button" class="btn btn-primary btn-sm" (click)="editImageMeta(image)">
                                                <img src="assets/images/icon-edit.svg" class="gallery-manage-edit">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>



                </div>
            </form>

        </div>
    </div>
</div>

<app-confirmation *ngIf="this.confirmationData.open" (complete)="delete($event)" [data]="confirmationData"></app-confirmation>

<app-gallery-image-manage [image]="imageToEdit" *ngIf="imageToEdit" (imageMetaUpdated)="imageMetaUpdated($event)"></app-gallery-image-manage>
